<template>
  <div class="bg">
    <div class="content pa bg_fff" @click.stop="cityBoxVisible = false">

      <div class="title">{{ titleText }}</div>

      <div class="form-content">

        <!-- 关键词 -->
        <div class="input-item">
          <span class="lable">关键词</span>
          <el-input v-model="formData.keyword" placeholder="请输入关键词" @focus="keywordError = false"></el-input>
          <!-- 错误提示 -->
          <div class="errorTipsDesc f_14" v-if="keywordError">
            <span class="iconfont icontishi"></span>
            <span class="tipsName">请输入关键词</span>
          </div>
        </div>

        <!-- 城市 -->
        <div class="input-item">
          <span class="lable">城市</span>
          <!-- <el-select v-model="city" class="select-input" placeholder="请选择城市" @visible-change="toggleCityBox"></el-select> -->
          <div class="city-input" :class="{'active': cityBoxVisible}" @click.stop="toggleCityBox">{{ formData.city || '全国' }}</div>
          <div class="city-box" v-show="cityBoxVisible">

            <div class="city-box-left">
              <span :class="{'active': nowCityIndex === -1}" @click.stop="handleCityList(hot_cities, -1)">热门城市</span>
              <span :class="{'active': indexTag === nowCityIndex}" v-for="(itemTag, indexTag) in cities" :key="indexTag + '&Tag'" @click.stop="handleCityList(itemTag.part_cities, indexTag)">{{ itemTag.group_name }}</span>
            </div>

            <div class="city-box-right">
              <span :class="{'active': itemCity.city_name === formData.city}" v-for="(itemCity, indexCity) in nowCityList" :key="indexCity + '&City'" @click.stop="handleCity(itemCity.city_name)">{{ itemCity.city_name }}</span>
            </div>

          </div>
        </div>

        <div class="input-row">
          <!-- 学历 -->
          <div class="input-row-item">
            <span class="lable">学历</span>
            <div class="input-row-item-mask" @click="showElSelectMenu('selectDegree')">{{ formData.degree.length ? formData.degree.join('，') : '不限' }}</div>
            <div data-growing-container data-growing-idx="100">
              <el-select  ref="selectDegree" v-model="formData.degree" multiple collapse-tags placeholder="不限">
                <el-option
                  v-for="item in selectData.degree"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 院校 -->
          <div class="input-row-item">
            <span class="lable">院校</span>
            <div class="input-row-item-mask" @click="showElSelectMenu('selectSchool')">{{ formData.school.length ? formData.school.join('，') : '不限' }}</div>
            <div data-growing-container data-growing-idx="200">
              <el-select  ref="selectSchool" v-model="formData.school" multiple collapse-tags placeholder="不限">
                <el-option
                  v-for="item in selectData.school"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </div>  
          </div>
        </div>

        <!-- 工作经验 -->
        <div class="input-item">
          <span class="lable">工作经验</span>
          <div class="input-item-mask" @click="showElSelectMenu('selectExperience')">{{ formData.experience.length ? formData.experience.join('，') : '不限' }}</div>
          <el-select ref="selectExperience" v-model="formData.experience" multiple collapse-tags placeholder="不限">
            <el-option
              v-for="item in selectData.experience"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>

      </div>

      <div class="formButtons templateButtons text_center clearfix">
        <div class="delete-button" @click="deleteFunc" v-if="backfillVisible">
          <i class="iconfont iconshanchu"></i>
          <span>删除订阅</span>
        </div>

        <div class="confirmButton f_14 fr" @click="confirmFunc">{{ confirmButtonText }}</div>
        <div class="cancelButton f_14 fr" @click="cancelFunc">{{ cancelButtonText }}</div>
      </div>

    </div>

    <tipsBlock v-if="tipsBlockVisible"
               tipsTitle="删除订阅提示"
               tipsText="即将删除该订阅"
               tipsHighlight="是否确认删除"
               @confirmFunc="tipsBlockConfirmFunc"
               @cancelFunc="tipsBlockCancelFunc"/>

  </div>
</template>

<script>
import searchMixins from '@/mixins/search/config'
import tipsBlock from '@/components/block/TipsBlock'

export default {
  props: {
    // 回填数据 visible
    backfillVisible: {
      type: Boolean,
      default: false
    },
    // 回填数据
    backfillData: {
      type: Object,
      default: () => {
        return {
          keyword: '',
          city: '全国',
          degree: [],
          school: [],
          experience: []
        }
      }
    },
    titleText: {
      type: String,
      default: '添加订阅'
    },
    confirmButtonText: {
      type: String,
      default: '确认'
    },
    cancelButtonText: {
      type: String,
      default: '取消'
    }
  },
  mixins: [searchMixins],
  data(){
    return {
      formData: {
        keyword: '', // 关键词 用户输入
        city: '全国', // 城市 单选
        degree: [], // 学历 多选
        school: [], // 院校 多选
        experience: [] // 工作经验 多选
      },
      nowCityIndex: -1, // 选择城市框里活跃索引
      nowCityList: [], // 选择城市框里的当前城市列表
      keywordError: false, // 是否填写关键词提示
      cityBoxVisible: false, // 选择城市框 visible
      tipsBlockVisible: false, // 确认删除二次弹窗 visible

      selectData: {
        degree: ['专科', '本科', '硕士', '博士', 'MBA'], //学历
        school: ['985/211', '海外前100'], //学校
        experience: ['在读', '应届生', '1-3年', '3-5年', '5-10年', '10年以上'] //经验
      }
    }
  },
  components: {
    tipsBlock
  },
  created () {
    // 初始化 选择城市框里的当前城市列表 是热门城市列表
    this.nowCityList = this.hot_cities
    // 禁止页面滚动
    document.body.style.position = 'static'
    document.body.style.overflow = 'hidden'
  },
  beforeDestroy() {
    // 接触禁止页面滚动
    document.body.style.position = 'initial'
    document.body.style.overflow = 'initial'
  },
  mounted () {
    if (this.backfillVisible) {
      this.formData = this.backfillData
    }
  },
  methods:{
    // 显示 elementUI 下拉框
    showElSelectMenu (ref) {
      this.$refs[ref].toggleMenu()
    },
    // 显示或者隐藏城市选择框
    toggleCityBox () {
      this.cityBoxVisible = !this.cityBoxVisible
    },
    // 选择城市
    handleCity (city) {
      this.formData.city = city
      this.cityBoxVisible = false
    },
    // 字母切换城市
    handleCityList (data, index) {
      this.nowCityList = data
      this.nowCityIndex = index
    },
    // 触发确认按钮
    confirmFunc () { 
      // 没有填写关键词 显示提示
      if (!this.formData.keyword) {
        this.keywordError = true
        return
      }
      this.$emit('confirmFunc', this.formData, this.backfillVisible)
    },
    // 触发取消按钮
    cancelFunc () {
      this.$emit('cancelFunc')
    },
    // 触发删除按钮
    deleteFunc () {
      this.tipsBlockVisible = true
    },
    tipsBlockConfirmFunc () {
      this.tipsBlockVisible = false
      this.$emit('deleteFunc')
    },
    tipsBlockCancelFunc () {
      this.tipsBlockVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .bg{
    position: fixed;
    z-index: 9;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: rgba($color: #000000, $alpha:0.5);

    .content{
      width: 540px;
      box-sizing: border-box;
      box-shadow:0px 1px 3px 0px rgba(0,0,0,0.03);
      border-radius:4px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      padding: 32px;

      .errorTipsDesc{
        color: #FD5F39;
        line-height: 24px;
        .iconfont{
          position: relative;
          top: 1px;
          margin-right: 8px;
        }
      }

      .input-item {
        position: relative;

        .input-item-mask {
          cursor: pointer;
          position: absolute;
          top: 31px;
          left: 2px;
          padding-left: 13px;
          z-index: 10;
          width: 430px;
          height: 30px;
          background: #ffffff;

          font-size: 14px;
          font-weight: 400;
          color: #404040;
          line-height: 30px;

          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

      .input-row {
        display: flex;
        justify-content: space-between;

        .input-row-item{
          position: relative;
          width: 228px;

          .input-row-item-mask {
            cursor: pointer;
            position: absolute;
            top: 47px;
            left: 2px;
            padding-left: 13px;
            z-index: 10;
            width: 180px;
            height: 30px;
            background: #ffffff;

            font-size: 14px;
            font-weight: 400;
            color: #404040;
            line-height: 30px;

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }

      .el-select {
        width: 100%;
      }

      .title{
        font-size: 16px;
        font-weight: 500;
        color: #404040;
        line-height: 14px;
      }

      .form-content {
        position: relative;
        margin-top: 16px;
      }

      .lable {
        display: block;
        font-size: 14px;
        font-weight: 400;
        color: #909090;
        line-height: 14px;
        margin-top: 16px;
        margin-bottom: 12px;
      }

      .select-input {
        width: 100%;
      }

      .city-input {
        cursor: pointer;
        padding: 0 18px 0 12px;
        height: 40px;
        border: 1px solid #ececec;

        font-size: 14px;
        font-weight: 400;
        color: #404040;
        line-height: 40px;
        box-sizing: border-box;

        &:hover,
        &.active {
          border-color: #c0c4cc;
        }
      }

      .city-box {
        position: absolute;
        z-index: 11;
        top: 71px;
        width: 100%;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #CECECE;

        display: flex;

        .city-box-left {
          width: 108px;
          height: 210px;
          overflow: auto;
          background: #F9F9F9;

          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none; /* IE 10+ */
          &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
          }

          >span {
            cursor: pointer;
            display: block;
            font-size: 14px;
            font-weight: 400;
            color: #606060;
            line-height: 20px;
            padding: 9px 0;
            text-align: center;

            &.active {
              font-weight: 500;
              color: #404040;
              background: #ffffff;
            }
          }
        }

        .city-box-right {
          flex: 1;
          padding-left: 14px;
          padding-top: 16px;

          height: 210px;
          overflow: auto;
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none; /* IE 10+ */
          &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
          }
          box-sizing: border-box;

          >span {
            display: inline-block;
            padding: 8px 16px;
            font-size: 14px;
            font-weight: 400;
            color: #9C9C9C;
            line-height: 14px;
            border-radius: 16px;
            border: 1px solid #ECECEC;
            margin-right: 8px;
            margin-bottom: 10px;
            cursor: pointer;

            &.active {
              color: #FF6644;
              border-color: #FF6644;
            }
          }
        }
      }

    }
  }
  .formButtons{
    margin-top: 36px;

    .delete-button {
      line-height: 36px;
      cursor: pointer;
      display: flex;
      align-items: center;
      float: left;
      color: #9C9C9C;
      font-size: 14px;
      font-weight: 400;

      >i {
        margin-right: 6px;
      }
    }

    .confirmButton{
      width: auto;
      padding: 0 28px;
      height: 36px;
      line-height: 36px;
      margin-left: 16px;
      background: #FF6644;
    }
    .cancelButton{
      width: auto;
      padding: 0 28px;
      height: 36px;
      line-height: 36px;
    }
  }
</style>
